(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const target = event.target instanceof Element ? event.target : null;
  const link = target && target.closest('[data-bb-footer-collector]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (window.pushowl && typeof window.pushowl.showWidget === 'function') {
    try {
      const result = window.pushowl.showWidget({type:'optinFlows', id:156685});
      event.preventDefault();
      if (result && typeof result.catch === 'function') result.catch(() => window.location.assign(link.href));
    } catch (error) {
      // Keep the contact link usable when the optional signup widget is unavailable.
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-home-spacing"]) return;
  try {
    
(() => {
  const instances = new Map();
  const mobile = window.matchMedia('(max-width: 749px)');
  function setup() {
    document.querySelectorAll('#MainContent .bbh [data-bb-feature]').forEach(feature => {
      if (instances.has(feature)) return;
      const track = feature.querySelector('[data-bb-feature-track]');
      if (!track) return;
      const slides = Array.from(track.children);
      if (!slides.length) return;
      let frame = 0;
      const listeners = new AbortController();
      function fitVisibleSlides() {
        frame = 0;
        if (!mobile.matches || !track.clientWidth) {
          track.style.removeProperty('height');
          return;
        }
        const bounds = track.getBoundingClientRect();
        // Only visible slides set the height; longer offscreen captions cannot leave a gap.
        const heights = slides.map(slide => slide.getBoundingClientRect())
          .filter(rect => rect.right > bounds.left + 1 && rect.left < bounds.right - 1)
          .map(rect => rect.height);
        if (!heights.length) return;
        const height = Math.ceil(Math.max(...heights));
        if (height > 0 && track.style.height !== height + 'px') track.style.height = height + 'px';
      }
      function schedule() {
        if (!frame) frame = requestAnimationFrame(fitVisibleSlides);
      }
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      slides.forEach(slide => observer?.observe(slide));
      track.addEventListener('scroll', schedule, { passive: true, signal: listeners.signal });
      feature.addEventListener('load', schedule, { capture: true, signal: listeners.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: listeners.signal });
      if (document.fonts) document.fonts.ready.then(() => {
        if (!listeners.signal.aborted) schedule();
      });
      instances.set(feature, () => {
        listeners.abort();
        observer?.disconnect();
        cancelAnimationFrame(frame);
        track.style.removeProperty('height');
      });
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, feature) => {
      if (event.target.contains(feature) || event.target.classList.contains('bb-home-spacing-support')) {
        dispose();
        instances.delete(feature);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-specialist-home"] && !Shopify.designMode) return;
  try {
    
function setupBBFeatures() {
  document.querySelectorAll('[data-bb-feature]').forEach(feature => {
    if (feature.dataset.ready) return;
    feature.dataset.ready = 'true';
    const track = feature.querySelector('[data-bb-feature-track]');
    const slides = Array.from(track.children);
    const prev = feature.querySelector('[data-bb-feature-prev]');
    const next = feature.querySelector('[data-bb-feature-next]');
    const count = feature.querySelector('[data-bb-feature-count]');
    const index = () => track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    function update() {
      const current = Math.min(slides.length - 1, Math.max(0, index()));
      count.textContent = (current + 1) + ' / ' + slides.length;
      prev.disabled = current === 0;
      next.disabled = current === slides.length - 1;
    }
    function move(direction) {
      const current = Math.min(slides.length - 1, Math.max(0, index() + direction));
      track.scrollTo({left: current * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    window.addEventListener('resize', update);
    update();
  });
}
setupBBFeatures();
document.addEventListener('shopify:section:load', setupBBFeatures);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
